export default {
  id: 'items',
  title: 'Artikli',
  icon: 'mdi-package-variant',
  show: true,
  order: 6,
  children: [
    {
      id: 'items-overview',
      title: 'Pregled artikala',
      icon: 'mdi-view-list',
      show: true,
      order: 1,
      content: getItemsOverviewContent
    },
    {
      id: 'items-add',
      title: 'Dodavanje artikla',
      icon: 'mdi-plus-circle',
      show: true,
      order: 2,
      content: getItemsAddContent
    },
    {
      id: 'items-types',
      title: 'Tipovi artikala',
      icon: 'mdi-shape',
      show: true,
      order: 3,
      content: getItemsTypesContent
    },
    {
      id: 'items-edit',
      title: 'Uređivanje artikla',
      icon: 'mdi-pencil',
      show: true,
      order: 4,
      content: getItemsEditContent
    },
    {
      id: 'items-upload',
      title: 'Grupno učitavanje',
      icon: 'mdi-file-upload',
      show: true,
      order: 5,
      content: getItemsUploadContent
    },
    {
      id: 'items-kpd-sifra',
      title: 'KPD Šifra',
      icon: 'mdi-barcode',
      show: true,
      order: 6,
      content: getItemsKpdSifraContent
    },
    {
      id: 'items-bulk-kpd',
      title: 'Grupni unos KPD šifri',
      icon: 'mdi-playlist-edit',
      show: true,
      order: 7,
      content: getItemsBulkKpdContent
    }
  ]
}

function getItemsOverviewContent () {
  return `
    <h2 id="items-overview">Pregled artikala</h2>
    <p>
      Modul "Artikli" prikazuje kompletnu listu svih artikala u sustavu.
      Artikli su osnovna jedinica prodaje - proizvodi ili usluge koje nudite svojim kupcima.
      Svaki artikl ima definirane karakteristike kao što su naziv, cijena, PDV stopa, kategorija i barcode.
    </p>

    <h3 class="mt-4">Pristup pregledu artikala</h3>

    <ol>
      <li>Iz glavnog izbornika idite na <strong>"Artikli" → "Pregled artikala"</strong></li>
      <li>Otvorit će se lista svih artikala u sustavu</li>
      <li>Možete pretraživati, filtrirati i sortirati artikle</li>
    </ol>

    <h3 class="mt-4">Prikaz artikla u listi</h3>

    <p>Svaki artikl u listi prikazuje sljedeće informacije:</p>

    <table class="info-table">
      <thead>
        <tr>
          <th>Kolona</th>
          <th>Opis</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td><strong>Naziv</strong></td>
          <td>Puni naziv artikla (npr. "Coca Cola 0.33L")</td>
        </tr>
        <tr>
          <td><strong>Barcode</strong></td>
          <td>Jedinstveni barcode ili PLU kod</td>
        </tr>
        <tr>
          <td><strong>Kategorija</strong></td>
          <td>Pripadajuća kategorija (npr. "Pića → Sokovi")</td>
        </tr>
        <tr>
          <td><strong>Tip</strong></td>
          <td>Roba, Usluga, Compound (složeni artikl)</td>
        </tr>
        <tr>
          <td><strong>Cijena</strong></td>
          <td>Osnovna prodajna cijena sa PDV-om</td>
        </tr>
        <tr>
          <td><strong>PDV</strong></td>
          <td>Stopa PDV-a (25%, 13%, 5%, 0%)</td>
        </tr>
        <tr>
          <td><strong>Status</strong></td>
          <td>Aktivan / Neaktivan</td>
        </tr>
      </tbody>
    </table>

    <h3 class="mt-4">Pretraživanje artikala</h3>

    <h4 class="mt-3">1. Osnovno pretraživanje</h4>
    <p>Koristite polje za pretraživanje na vrhu liste:</p>
    <ul>
      <li>Unesite naziv artikla (npr. "kava")</li>
      <li>Unesite barcode (npr. "385...")</li>
      <li>Unesite PLU kod</li>
      <li>Sustav automatski filtrira rezultate</li>
    </ul>

    <h4 class="mt-3">2. Napredno filtriranje</h4>
    <p>Kliknite na <i class="mdi mdi-filter"></i> <strong>"Filteri"</strong> za napredne opcije:</p>
    <ul>
      <li><strong>Po kategoriji</strong> - Prikažite samo artikle iz određene kategorije</li>
      <li><strong>Po tipu</strong> - Roba, Usluga, ili Compound</li>
      <li><strong>Po PDV stopi</strong> - Filtrirajte po PDV stopi (25%, 13%, 5%, 0%)</li>
      <li><strong>Po statusu</strong> - Aktivni ili neaktivni artikli</li>
      <li><strong>Po prodajnom mjestu</strong> - Artikli dostupni na određenom POS-u</li>
    </ul>

    <div class="info-box">
      <i class="mdi mdi-information" style="color: #3989C9; margin-right: 8px; font-size: 20px;"></i>
      <div>
        <strong>Savjet:</strong> Kombinirajte više filtera za preciznije rezultate.
        Na primjer, možete prikazati samo aktivne artikle iz kategorije "Pića" sa PDV stopom 25%.
      </div>
    </div>

    <h3 class="mt-4">Sortiranje</h3>

    <p>Kliknite na zaglavlje kolone za sortiranje:</p>
    <ul>
      <li><strong>Naziv</strong> - Alfabetski A-Z ili Z-A</li>
      <li><strong>Cijena</strong> - Od najniže do najviše ili obrnuto</li>
      <li><strong>Kategorija</strong> - Alfabetski po kategorijama</li>
      <li><strong>Datum kreiranja</strong> - Najnoviji ili najstariji prvo</li>
    </ul>

    <h3 class="mt-4">Akcije nad artiklima</h3>

    <p>Za svaki artikl dostupne su sljedeće akcije:</p>

    <table class="info-table">
      <thead>
        <tr>
          <th>Akcija</th>
          <th>Ikona</th>
          <th>Opis</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td><strong>Detalji</strong></td>
          <td><i class="mdi mdi-eye"></i></td>
          <td>Pregled svih informacija o artiklu</td>
        </tr>
        <tr>
          <td><strong>Uredi</strong></td>
          <td><i class="mdi mdi-pencil"></i></td>
          <td>Izmjena podataka o artiklu</td>
        </tr>
        <tr>
          <td><strong>Kopiraj</strong></td>
          <td><i class="mdi mdi-content-copy"></i></td>
          <td>Kreiranje kopije artikla</td>
        </tr>
        <tr>
          <td><strong>Deaktiviraj</strong></td>
          <td><i class="mdi mdi-archive"></i></td>
          <td>Deaktivacija artikla (ne briše se, postaje nevidljiv)</td>
        </tr>
        <tr>
          <td><strong>Obriši</strong></td>
          <td><i class="mdi mdi-delete"></i></td>
          <td>Trajno brisanje artikla (samo ako nema transakcija)</td>
        </tr>
      </tbody>
    </table>

    <div class="warning-box">
      <i class="mdi mdi-alert" style="color: #FF9800; margin-right: 8px; font-size: 20px;"></i>
      <div>
        <strong>Napomena:</strong> Artikle koji imaju povijesne transakcije (prodaje) nije moguće obrisati,
        ali ih možete deaktivirati kako ne bi bili dostupni za daljnju prodaju.
      </div>
    </div>

    <h3 class="mt-4">Grupne akcije</h3>

    <p>Možete odabrati više artikala i izvršiti grupne akcije:</p>
    <ol>
      <li>Označite artikle pomoću checkboxa</li>
      <li>Odaberite akciju iz dropdown menija "Grupne akcije"</li>
      <li>Kliknite <strong>"Izvedi"</strong></li>
    </ol>

    <p>Dostupne grupne akcije:</p>
    <ul>
      <li><strong>Promjena kategorije</strong> - Premještanje u drugu kategoriju</li>
      <li><strong>Promjena PDV stope</strong> - Primjena nove PDV stope</li>
      <li><strong>Deaktivacija</strong> - Deaktiviranje svih odabranih artikala</li>
      <li><strong>Export u Excel</strong> - Izvoz odabranih artikala</li>
    </ul>

    <h3 class="mt-4">Dodavanje novog artikla</h3>

    <p>Za kreiranje novog artikla:</p>
    <ol>
      <li>Kliknite <strong>"+ Dodaj artikl"</strong> gumb na vrhu liste</li>
      <li>Otvorit će se forma za unos podataka</li>
      <li>Popunite obavezna polja i spremite</li>
    </ol>

    <div class="success-box">
      <i class="mdi mdi-lightbulb" style="color: #4CAF50; margin-right: 8px; font-size: 20px;"></i>
      <div>
        <strong>Savjet:</strong> Možete brzo dodavati velike količine artikala pomoću Excel importa.
        Preuzmite predložak, popunite podatke i učitajte natrag u sustav.
      </div>
    </div>

    <h3 class="mt-4">Export i Import</h3>

    <h4 class="mt-3">Export artikala</h4>
    <ol>
      <li>Kliknite <i class="mdi mdi-download"></i> <strong>"Export"</strong></li>
      <li>Odaberite format: Excel (.xlsx) ili CSV</li>
      <li>Odaberite kolone koje želite exportati</li>
      <li>Preuzmite datoteku</li>
    </ol>

    <h4 class="mt-3">Import artikala</h4>
    <ol>
      <li>Kliknite <i class="mdi mdi-upload"></i> <strong>"Import"</strong></li>
      <li>Preuzmite predložak (template)</li>
      <li>Popunite artikle u Excel datoteci</li>
      <li>Učitajte datoteku i pokrenite import</li>
      <li>Provjerite greške i završite import</li>
    </ol>

    <h3 class="mt-4">Često postavljana pitanja</h3>

    <h4 class="mt-3">Koliko artikala mogu imati u sustavu?</h4>
    <p>
      Nema ograničenja broja artikala. Sustav podržava neograničen broj artikala,
      ovisno o vašem pretplatničkom paketu.
    </p>

    <h4 class="mt-3">Mogu li obrisati artikl koji sam već prodao?</h4>
    <p>
      Ne, artikl s povijesnim transakcijama ne možete obrisati radi očuvanja integriteta podataka.
      Međutim, možete ga deaktivirati kako ne bi bio dostupan za daljnju prodaju.
    </p>

    <h4 class="mt-3">Kako prikazati samo aktivne artikle?</h4>
    <p>
      Koristite filter "Status" i odaberite "Aktivni". Time ćete sakriti sve deaktivirane artikle iz liste.
    </p>

    <h4 class="mt-3">Mogu li isti artikl imati različite cijene na različitim prodajnim mjestima?</h4>
    <p>
      Da, kroz sustav cjenika možete definirati različite cijene za isti artikl na različitim prodajnim mjestima.
    </p>
  `
}

function getItemsAddContent () {
  return `
    <h2 id="what-is">Što je dodavanje artikla?</h2>
    <p>Dodavanje novog artikla u sustav omogućuje kreiranje stavke koja se može prodavati na blagajni. Artikl sadrži osnovne informacije: naziv, cijenu, PDV stopu, tip, kategoriju i barcode.</p>

    <h2 id="when-to-use" class="mt-6">Kada koristiti?</h2>
    <ul>
      <li>Pri postavljanju cjenika za novo prodajno mjesto</li>
      <li>Kada dodajete novi proizvod ili uslugu u ponudu</li>
      <li>Za kreiranje posebnih artikala (popusti, write-in artikli)</li>
    </ul>

    <h2 id="prerequisites" class="mt-6">Preduvjeti</h2>
    <ul>
      <li>Pristup modulu "Artikli i cjenik"</li>
      <li>Minimalno jedna kategorija kreirana</li>
      <li>Znanje o PDV stopi koja se primjenjuje na artikl</li>
    </ul>

    <h2 id="step-by-step" class="mt-6">Korak po korak</h2>

    <h3 class="mt-4">1. Otvaranje forme za dodavanje</h3>
    <ol>
      <li>Idite na <strong>"Artikli i cjenik" → "Artikli"</strong></li>
      <li>Kliknite gumb <i class="mdi mdi-plus" style="color: #3989C9; margin: 0 4px; font-size: 16px;"></i> <strong>"Dodaj artikl"</strong> u gornjem desnom kutu</li>
      <li>Otvara se forma sa svim poljima</li>
    </ol>

    <h3 class="mt-4">2. Popunjavanje osnovnih podataka</h3>
    <p>Obavezna polja označena su zvjezdicom (*):</p>
    <table class="info-table">
      <thead>
        <tr>
          <th>Polje</th>
          <th>Opis</th>
          <th>Primjer</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td><strong>Naziv*</strong></td>
          <td>Naziv artikla koji se prikazuje na računu</td>
          <td>"Coca Cola 0.33L", "Cappuccino", "Frizer - šišanje"</td>
        </tr>
        <tr>
          <td><strong>Šifra</strong></td>
          <td>Jedinstvena interna šifra (SKU)</td>
          <td>"ART-001", "KAV-CAP-01"</td>
        </tr>
        <tr>
          <td><strong>Tip*</strong></td>
          <td>Vrsta artikla</td>
          <td>PRODUCT, SERVICE, WRITE_IN, DISCOUNT</td>
        </tr>
        <tr>
          <td><strong>Kategorija*</strong></td>
          <td>Pripadnost kategoriji</td>
          <td>"Pića", "Kava", "Usluge"</td>
        </tr>
        <tr>
          <td><strong>PDV stopa*</strong></td>
          <td>Porezna stopa koja se primjenjuje</td>
          <td>25%, 13%, 5%, 0%</td>
        </tr>
        <tr>
          <td><strong>Cijena</strong></td>
          <td>Osnovna cijena (bez PDV-a ili sa PDV-om ovisno o postavkama)</td>
          <td>2.50, 15.00, 100.00</td>
        </tr>
        <tr>
          <td><strong>Barcode</strong></td>
          <td>EAN/UPC kod za skeniranje</td>
          <td>"5449000000996", "8001505001518"</td>
        </tr>
      </tbody>
    </table>

    <h3 class="mt-4">3. Odabir tipa artikla</h3>
    <p>Tip artikla određuje kako se artikl ponaša na blagajni:</p>
    <ul>
      <li><strong>PRODUCT</strong> - Standardni fizički proizvod s fiksnom cijenom</li>
      <li><strong>SERVICE</strong> - Usluga (nematerijalnastavka)</li>
      <li><strong>WRITE_IN</strong> - Artikl čija se cijena unosi pri svakoj prodaji (npr. "Razno")</li>
      <li><strong>DISCOUNT</strong> - Poseban artikl za popuste na računu</li>
    </ul>

    <h3 class="mt-4">4. Dodavanje barcode-a (opcionalno)</h3>
    <ol>
      <li>Kliknite u polje "Barcode"</li>
      <li>Skenirajte barcode čitačem ili upišite ručno</li>
      <li>Provjerite je li format ispravan (EAN-13: 13 znamenki)</li>
    </ol>
    <div class="warning-box">
      <i class="mdi mdi-alert" style="color: #FF9800; margin-right: 8px; font-size: 20px;"></i>
      <div>
        <strong>Važno:</strong> Jedan barcode može biti dodijeljen samo jednom artiklu. Sustav će vas upozoriti ako pokušate koristiti duplikat.
      </div>
    </div>

    <h3 class="mt-4">5. Spremanje artikla</h3>
    <ol>
      <li>Provjerite jesu li sva obavezna polja popunjena</li>
      <li>Kliknite <strong>"Spremi"</strong></li>
      <li>Artikl je sada dostupan u listi artikala</li>
      <li>Da bi bio dostupan na blagajni, potrebno ga je dodati na cjenik</li>
    </ol>

    <div class="success-box">
      <i class="mdi mdi-lightbulb" style="color: #4CAF50; margin-right: 8px; font-size: 20px;"></i>
      <div>
        <strong>Savjet:</strong> Nakon spremanja, odmah dodajte artikl na cjenik ako ga želite odmah koristiti na blagajni. Idite na "Cjenik" → "Dodaj artikl".
      </div>
    </div>

    <h2 id="tips" class="mt-6">Savjeti i trikovi</h2>
    <ul>
      <li><strong>Imenovanje artikala:</strong> Koristite jasne, kratke nazive jer se prikazuju na računima (max 30-40 znakova)</li>
      <li><strong>Šifre:</strong> Uspostavite konzistentan sistem šifriranja (npr. KAT-PODKAT-RB)</li>
      <li><strong>Kategorije:</strong> Dobro organizirane kategorije olakšavaju pronalaženje na blagajni</li>
      <li><strong>Barcode:</strong> Ako nemate fizički barcode, možete generirati vlastiti ili ostaviti prazno</li>
      <li><strong>PDV:</strong> Provjrite primjenjuje li se standardna (25%) ili snižena stopa za vaš tip artikla</li>
    </ul>

    <h2 id="troubleshooting" class="mt-6">Što ako...?</h2>

    <details>
      <summary>Ne mogu pronaći kategoriju u padajućem izborniku?</summary>
      <p>Kategorija mora biti kreirana prije dodavanja artikla:</p>
      <ol>
        <li>Idite na "Artikli i cjenik" → "Kategorije"</li>
        <li>Dodajte novu kategoriju</li>
        <li>Vratite se na dodavanje artikla</li>
      </ol>
    </details>

    <details>
      <summary>Sustav javlja da barcode već postoji?</summary>
      <p>Jedan barcode može biti dodijeljen samo jednom artiklu. Opcije:</p>
      <ul>
        <li>Provjerite je li artikl možda već kreiran</li>
        <li>Upotrijebite drugačiji barcode</li>
        <li>Kontaktirajte dobavljača za ispravan barcode</li>
      </ul>
    </details>

    <details>
      <summary>Artikl ne vidim na blagajni nakon spremanja?</summary>
      <p>Artikl mora biti dodan na cjenik da bi bio vidljiv:</p>
      <ol>
        <li>Idite na "Artikli i cjenik" → "Cjenik"</li>
        <li>Kliknite "Dodaj artikl"</li>
        <li>Odaberite artikl i unesite cijenu</li>
        <li>Spremite</li>
      </ol>
    </details>

    <details>
      <summary>Treba li cijena uključivati PDV?</summary>
      <p>Ovisi o postavkama kompanije:</p>
      <ul>
        <li>Provjerite u "Postavke" → "Općenito" → "Cijene sadrže PDV"</li>
        <li>Ako je označeno: unosite cijenu S PDV-om (npr. 25 kn)</li>
        <li>Ako nije označeno: unosite cijenu BEZ PDV-a (npr. 20 kn + 25% = 25 kn)</li>
      </ul>
    </details>

    <details>
      <summary>Kada koristiti tip WRITE_IN?</summary>
      <p>WRITE_IN artikle koristite za:</p>
      <ul>
        <li>Artikle čija cijena varira (npr. "Razno", "Ostalo")</li>
        <li>Proizvode koji se prodaju po težini (kg, dag)</li>
        <li>Situacije gdje treba ručno unijeti cijenu pri prodaji</li>
      </ul>
      <p>Pri dodavanju WRITE_IN artikla na račun, blagajna će tražiti unos cijene.</p>
    </details>
  `
}

function getItemsTypesContent () {
  return `
    <h2>Tipovi artikala</h2>
    <p>AI Kasa podržava različite tipove artikala ovisno o vrsti poslovanja.</p>

    <h3 class="mt-4">Tipovi</h3>
    <table class="info-table">
      <thead>
        <tr>
          <th>Tip</th>
          <th>Opis</th>
          <th>Primjena</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td><strong>PRODUCT</strong></td>
          <td>Fizički proizvod</td>
          <td>Standardni artikli za prodaju (hrana, pića, roba)</td>
        </tr>
        <tr>
          <td><strong>SERVICE</strong></td>
          <td>Usluga</td>
          <td>Nematerijalni proizvodi (fri zemlja, servis, consultingzerijalna)</td>
        </tr>
        <tr>
          <td><strong>WRITE_IN</strong></td>
          <td>Upisni artikal</td>
          <td>Artikl čija se cijena unosi pri prodaji</td>
        </tr>
        <tr>
          <td><strong>DISCOUNT</strong></td>
          <td>Popust</td>
          <td>Poseban artikal za popuste na računu</td>
        </tr>
      </tbody>
    </table>
  `
}

function getItemsEditContent () {
  return `
    <h2 id="what-is">Što je uređivanje artikla?</h2>
    <p>Uređivanje omogućuje izmjenu postojećih podataka o artiklu: naziva, cijene, kategorije, PDV stope, barcode-a i drugih postavki. Izmjene se odmah primjenjuju na sve cjenike gdje artikl postoji.</p>

    <h2 id="when-to-use" class="mt-6">Kada koristiti?</h2>
    <ul>
      <li>Kada se promijeni cijena artikla</li>
      <li>Za ispravljanje pogrešno unesenih podataka (naziv, šifra, PDV)</li>
      <li>Kod promjene kategorije ili tipa artikla</li>
      <li>Za dodavanje ili izmjenu barcode-a</li>
      <li>Kad artikl treba označiti kao neaktivan</li>
    </ul>

    <h2 id="prerequisites" class="mt-6">Preduvjeti</h2>
    <ul>
      <li>Pristup modulu "Artikli i cjenik"</li>
      <li>Artikl mora biti prethodno kreiran u sustavu</li>
    </ul>

    <h2 id="step-by-step" class="mt-6">Korak po korak</h2>

    <h3 class="mt-4">1. Pronalaženje artikla</h3>
    <ol>
      <li>Idite na <strong>"Artikli i cjenik" → "Artikli"</strong></li>
      <li>Koristite pretragu ili filtere za pronalaženje artikla:
        <ul>
          <li>Pretraživanje po nazivu</li>
          <li>Filtriranje po kategoriji</li>
          <li>Filtriranje po tipu (PRODUCT, SERVICE, itd.)</li>
          <li>Sortiranje po datumu ili abecedi</li>
        </ul>
      </li>
      <li>Pronađite artikl u listi</li>
    </ol>

    <h3 class="mt-4">2. Otvaranje forme za uređivanje</h3>
    <p>Postoje 2 načina za otvaranje:</p>
    <table class="info-table">
      <thead>
        <tr>
          <th>Način</th>
          <th>Koraci</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td><strong>Ikona olovke</strong></td>
          <td>Kliknite ikonu <i class="mdi mdi-pencil" style="color: #3989C9; margin: 0 4px; font-size: 16px;"></i> u redu artikla</td>
        </tr>
        <tr>
          <td><strong>Klik na redak</strong></td>
          <td>Kliknite bilo gdje na redak artikla da otvorite detalje, zatim "Uredi"</td>
        </tr>
      </tbody>
    </table>

    <h3 class="mt-4">3. Izmjena podataka</h3>
    <p>U formi možete izmijeniti:</p>
    <ul>
      <li><strong>Naziv</strong> - Prikazuje se na računu i blagajni</li>
      <li><strong>Šifra</strong> - Interna šifra (SKU) za identifikaciju</li>
      <li><strong>Tip</strong> - PRODUCT, SERVICE, WRITE_IN, DISCOUNT</li>
      <li><strong>Kategorija</strong> - Pripadnost kategoriji</li>
      <li><strong>PDV stopa</strong> - 0%, 5%, 13%, 25%</li>
      <li><strong>Barcode</strong> - EAN/UPC kod</li>
      <li><strong>Status</strong> - Aktivan/Neaktivan</li>
    </ul>

    <div class="warning-box">
      <i class="mdi mdi-alert" style="color: #FF9800; margin-right: 8px; font-size: 20px;"></i>
      <div>
        <strong>Pozor:</strong> Promjena cijene u ovoj formi NE mijenja cijenu na cjeniku. Cijena na cjeniku se uređuje odvojeno u "Cjenik" modulu.
      </div>
    </div>

    <h3 class="mt-4">4. Deaktiviranje artikla (opcionalno)</h3>
    <p>Ako artikl više ne želite koristiti, ali ne želite ga obrisati:</p>
    <ol>
      <li>U formi pronađite polje <strong>"Status"</strong> ili <strong>"Aktivan"</strong></li>
      <li>Označite kao <span class="status-chip grey">Neaktivan</span></li>
      <li>Artikl više neće biti dostupan na blagajni, ali ostaje u povijesti</li>
    </ol>

    <h3 class="mt-4">5. Spremanje izmjena</h3>
    <ol>
      <li>Provjerite sve izmjene</li>
      <li>Kliknite <strong>"Spremi"</strong></li>
      <li>Izmjene su odmah vidljive u sustavu</li>
    </ol>

    <div class="success-box">
      <i class="mdi mdi-lightbulb" style="color: #4CAF50; margin-right: 8px; font-size: 20px;"></i>
      <div>
        <strong>Savjet:</strong> Ako mijenjate cijenu, radije to napravite preko "Cjenik" modula gdje možete postaviti različite cijene za različita prodajna mjesta.
      </div>
    </div>

    <h2 id="tips" class="mt-6">Savjeti i trikovi</h2>
    <ul>
      <li><strong>Brzo uređivanje:</strong> Koristite tipkovničku prečicu ili double-click na redak za brzo otvaranje</li>
      <li><strong>Povijest izmjena:</strong> Sustav bilježi tko je i kada izvršio izmjenu</li>
      <li><strong>Grupne izmjene:</strong> Za mijenjanje više artikala odjednom, koristite funkciju "Grupno uređivanje" ako je dostupna</li>
      <li><strong>PDV izmjene:</strong> Budite oprezni pri mijenjanju PDV stope - utječe na fiskalizaciju</li>
    </ul>

    <h2 id="troubleshooting" class="mt-6">Što ako...?</h2>

    <details>
      <summary>Ne mogu izmijeniti artikl (gumb "Spremi" je onemogućen)?</summary>
      <p>Mogući razlozi:</p>
      <ul>
        <li><strong>Niste napravili izmjene</strong> - Izmjenite barem jedno polje</li>
        <li><strong>Obavezna polja nisu popunjena</strong> - Provjerite da naziv, tip i kategorija nisu prazni</li>
        <li><strong>Nemate dozvolu</strong> - Kontaktirajte administratora za provjeru pristupa</li>
      </ul>
    </details>

    <details>
      <summary>Promijenio sam cijenu, ali se ne mijenja na blagajni?</summary>
      <p>Cijena na blagajni dolazi iz <strong>cjenika</strong>, ne iz osnovnih podataka artikla:</p>
      <ol>
        <li>Idite na "Artikli i cjenik" → "Cjenik"</li>
        <li>Pronađite artikl u cjeniku</li>
        <li>Kliknite na ikonu olovke <i class="mdi mdi-pencil" style="color: #3989C9; margin: 0 4px; font-size: 16px;"></i></li>
        <li>Unesite novu cijenu</li>
        <li>Spremite</li>
      </ol>
    </details>

    <details>
      <summary>Mogu li obrisati artikl?</summary>
      <p>Artikl se ne može obrisati ako:</p>
      <ul>
        <li>Postoji na nekim računima (postoji u povijesti prodaje)</li>
        <li>Trenutno je na otvorenom računu</li>
        <li>Dio je aktivne narudžbe</li>
      </ul>
      <p><strong>Alternativa:</strong> Označite artikl kao <span class="status-chip grey">Neaktivan</span>. To će ga sakriti sa blagajne, ali ostaje u povijesti za izvještavanje.</p>
    </details>

    <details>
      <summary>Što se događa s računima koji već sadrže stari artikl?</summary>
      <p>Izmjene artikla <strong>NE UTJEČU</strong> na već izdane račune:</p>
      <ul>
        <li>Stari računi zadržavaju originalne podatke (naziv, cijena)</li>
        <li>Izmjene se primjenjuju samo na nove račune</li>
        <li>Povijest je zaštićena zbog zakonskih i fiskalnih razloga</li>
      </ul>
    </details>

    <details>
      <summary>Promijenio sam naziv, hoće li se ažurirati na svim mjestima?</summary>
      <p>Da, promjena naziva se automatski primjenjuje na:</p>
      <ul>
        <li><i class="mdi mdi-check" style="color: #4CAF50; margin-right: 4px;"></i> Blagajni (novi računi)</li>
        <li><i class="mdi mdi-check" style="color: #4CAF50; margin-right: 4px;"></i> Cjeniku</li>
        <li><i class="mdi mdi-check" style="color: #4CAF50; margin-right: 4px;"></i> Izvještajima</li>
        <li><i class="mdi mdi-close" style="color: #F44336; margin-right: 4px;"></i> Starim računima (zadržavaju originalni naziv)</li>
      </ul>
    </details>

    <details>
      <summary>Mogu li promijeniti tip artikla (npr. iz PRODUCT u SERVICE)?</summary>
      <p>Promjena tipa je moguća, ali:</p>
      <ul>
        <li><strong>Preporuča se oprez</strong> - različiti tipovi imaju različito ponašanje</li>
        <li>Ako artikl ima povijest prodaje, bolje je kreirati novi artikl željenog tipa</li>
        <li>Deaktivirajte stari i kreirajte novi s istim nazivom ali drugim tipom</li>
      </ul>
    </details>
  `
}

function getItemsUploadContent () {
  return `
    <h2 id="what-is">Što je grupno učitavanje (CSV)?</h2>
    <p>Grupno učitavanje omogućuje dodavanje velikog broja artikala odjednom pomoću CSV (Comma-Separated Values) datoteke. Idealno za migraciju postojećih cjenika ili početno postavljanje sustava.</p>

    <h2 id="when-to-use" class="mt-6">Kada koristiti?</h2>
    <ul>
      <li>Pri početnom postavljanju sustava (migracija sa starog sustava)</li>
      <li>Dodavanje više od 10-20 artikala odjednom</li>
      <li>Uvoz cjenika od dobavljača</li>
      <li>Periodično ažuriranje cijena iz eksternih izvora</li>
    </ul>

    <h2 id="prerequisites" class="mt-6">Preduvjeti</h2>
    <ul>
      <li>Pristup modulu "Artikli i cjenik"</li>
      <li>CSV datoteka s artiklima u ispravnom formatu</li>
      <li>Kategorije već kreirane u sustavu (ako koristite kategorije u CSV-u)</li>
      <li>Osnovno znanje rada s Excel/LibreOffice Calc programima</li>
    </ul>

    <h2 id="step-by-step" class="mt-6">Korak po korak</h2>

    <h3 class="mt-4">1. Priprema CSV datoteke</h3>
    <p>CSV datoteka mora sadržavati sljedeće kolone (prvi redak = zaglavlja):</p>
    <table class="info-table">
      <thead>
        <tr>
          <th>Kolona</th>
          <th>Obavezno?</th>
          <th>Opis</th>
          <th>Primjer</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td><strong>name</strong></td>
          <td><span class="status-chip error">DA</span></td>
          <td>Naziv artikla</td>
          <td>Coca Cola 0.33L</td>
        </tr>
        <tr>
          <td><strong>code</strong></td>
          <td><span class="status-chip grey">NE</span></td>
          <td>Interna šifra (SKU)</td>
          <td>ART-001</td>
        </tr>
        <tr>
          <td><strong>type</strong></td>
          <td><span class="status-chip error">DA</span></td>
          <td>Tip artikla</td>
          <td>PRODUCT</td>
        </tr>
        <tr>
          <td><strong>category</strong></td>
          <td><span class="status-chip error">DA</span></td>
          <td>Naziv kategorije</td>
          <td>Pića</td>
        </tr>
        <tr>
          <td><strong>vat_rate</strong></td>
          <td><span class="status-chip error">DA</span></td>
          <td>PDV stopa (decimalni broj)</td>
          <td>0.25 (za 25%)</td>
        </tr>
        <tr>
          <td><strong>price</strong></td>
          <td><span class="status-chip grey">NE</span></td>
          <td>Osnovna cijena</td>
          <td>2.50</td>
        </tr>
        <tr>
          <td><strong>barcode</strong></td>
          <td><span class="status-chip grey">NE</span></td>
          <td>EAN/UPC kod</td>
          <td>5449000000996</td>
        </tr>
      </tbody>
    </table>

    <h3 class="mt-4">2. Primjer CSV datoteke</h3>
    <p>Otvorite Excel ili bilo koji tekst editor i kreirajte datoteku s ovim sadržajem:</p>
    <div class="tip-box" style="background-color: #f5f5f5; padding: 16px; border-radius: 8px; font-family: monospace; overflow-x: auto;">
      name,code,type,category,vat_rate,price,barcode<br>
      Coca Cola 0.33L,ART-001,PRODUCT,Pića,0.25,2.50,5449000000996<br>
      Cappuccino,KAV-CAP,PRODUCT,Kava,0.13,8.00,<br>
      Šišanje - kratka kosa,USL-001,SERVICE,Usluge,0.25,50.00,<br>
      Popust 10%,DISC-10,DISCOUNT,Popusti,0.00,-10.00,
    </div>

    <h3 class="mt-4">3. Spremanje kao CSV</h3>
    <ol>
      <li>U Excelu: <strong>File → Save As → CSV (Comma delimited) (*.csv)</strong></li>
      <li>Odaberite lokaciju za spremanje</li>
      <li>Provjerite da je odabran format <strong>CSV UTF-8</strong> (za hrvatske znakove)</li>
      <li>Kliknite "Save"</li>
    </ol>

    <div class="warning-box">
      <i class="mdi mdi-alert" style="color: #FF9800; margin-right: 8px; font-size: 20px;"></i>
      <div>
        <strong>Važno:</strong> Koristite točku (.) kao decimalni separator, ne zarez (,). Primjer: 2.50, ne 2,50
      </div>
    </div>

    <h3 class="mt-4">4. Upload CSV datoteke</h3>
    <ol>
      <li>Idite na <strong>"Artikli i cjenik" → "Artikli"</strong></li>
      <li>Kliknite gumb <i class="mdi mdi-file-upload" style="color: #3989C9; margin: 0 4px; font-size: 16px;"></i> <strong>"Uvoz CSV"</strong> ili <strong>"Grupno učitavanje"</strong></li>
      <li>Otvorit će se dialog za odabir datoteke</li>
      <li>Kliknite <strong>"Choose File"</strong> ili povucite CSV datoteku u označeno područje</li>
      <li>Odaberite CSV datoteku s računala</li>
      <li>Kliknite <strong>"Upload"</strong></li>
    </ol>

    <h3 class="mt-4">5. Provjera i potvrda</h3>
    <ol>
      <li>Sustav će prikazati pregled artikala koji će biti dodani</li>
      <li>Provjerite je li broj redaka ispravan</li>
      <li>Pregledajte eventualne greške ili upozorenja:
        <ul>
          <li><span class="status-chip error">ERROR</span> - Artikl neće biti dodan (npr. nedostaje obavezno polje)</li>
          <li><span class="status-chip warning">WARNING</span> - Artikl će biti dodan, ali provjerite podatke</li>
          <li><span class="status-chip success">OK</span> - Artikl je spreman za uvoz</li>
        </ul>
      </li>
      <li>Kliknite <strong>"Potvrdi uvoz"</strong></li>
      <li>Sustav će dodati sve ispravne artikle</li>
    </ol>

    <div class="success-box">
      <i class="mdi mdi-lightbulb" style="color: #4CAF50; margin-right: 8px; font-size: 20px;"></i>
      <div>
        <strong>Savjet:</strong> Preporučujemo prvo testirati s malom CSV datotekom (5-10 artikala) prije nego uvezete cijeli cjenik.
      </div>
    </div>

    <h2 id="tips" class="mt-6">Savjeti i trikovi</h2>
    <ul>
      <li><strong>Encoding:</strong> Koristite UTF-8 encoding za hrvatske znakove (č, ć, š, đ, ž)</li>
      <li><strong>Separator:</strong> Standardni separator je zarez (,). Ako vaši podaci sadrže zareze, stavite ih u navodnike</li>
      <li><strong>Prazna polja:</strong> Opcionalna polja možete ostaviti prazna, ali separator mora biti prisutan</li>
      <li><strong>Kategorije:</strong> Nazivi kategorija moraju točno odgovarati onima u sustavu (velika/mala slova bitna!)</li>
      <li><strong>Testiranje:</strong> Preuzmite i provjerite primjer CSV datoteke iz sustava (gumb "Preuzmi predložak")</li>
      <li><strong>Backup:</strong> Prije uvoza velikog broja artikala, napravite izvoz postojećih kao sigurnosnu kopiju</li>
    </ul>

    <h2 id="troubleshooting" class="mt-6">Što ako...?</h2>

    <details>
      <summary>Dobivam grešku "Invalid CSV format"?</summary>
      <p>Provjere:</p>
      <ul>
        <li><strong>Zaglavlja:</strong> Prvi redak mora sadržavati točne nazive kolona (name, code, type, itd.)</li>
        <li><strong>Encoding:</strong> Provjerite je li datoteka spremljena kao UTF-8</li>
        <li><strong>Separator:</strong> Koristite zarez (,) kao separator, ne točku-zarez (;)</li>
        <li><strong>Prazan fajl:</strong> Datoteka mora sadržavati barem 2 retka (zaglavlje + 1 artikl)</li>
      </ul>
    </details>

    <details>
      <summary>Greška "Category not found"?</summary>
      <p>Kategorije moraju postojati prije uvoza artikala:</p>
      <ol>
        <li>Idite na "Artikli i cjenik" → "Kategorije"</li>
        <li>Dodajte sve potrebne kategorije koje se pojavljuju u CSV-u</li>
        <li>Pazite na točan naziv (veliko/malo slovo, razmaci)</li>
        <li>Ponovite upload CSV-a</li>
      </ol>
    </details>

    <details>
      <summary>Neki artikli nisu dodani?</summary>
      <p>Provjerite prikaz rezultata nakon uvoza:</p>
      <ul>
        <li><strong>Dupli barcode:</strong> Barcode već postoji na drugom artiklu</li>
        <li><strong>Dupli code:</strong> Interna šifra već postoji</li>
        <li><strong>Nevažeći tip:</strong> Tip mora biti: PRODUCT, SERVICE, WRITE_IN ili DISCOUNT</li>
        <li><strong>Nevažeća PDV stopa:</strong> Koristite decimalni format (0.25 za 25%)</li>
      </ul>
      <p>Ispravite greške u CSV datoteci i ponovite uvoz samo za neuspješne artikle.</p>
    </details>

    <details>
      <summary>Hrvatski znakovi se ne prikazuju ispravno (č, ć, š)?</summary>
      <p>Problem s encoding-om:</p>
      <ol>
        <li>Otvorite CSV u Notepad++ ili VS Code</li>
        <li>Odaberite <strong>Encoding → Convert to UTF-8</strong></li>
        <li>Spremite datoteku</li>
        <li>Ili u Excelu: <strong>Save As → CSV UTF-8 (Comma delimited)</strong></li>
      </ol>
    </details>

    <details>
      <summary>Mogu li ažurirati postojeće artikle preko CSV-a?</summary>
      <p>Ovisi o postavkama sustava:</p>
      <ul>
        <li>Neki sustavi podržavaju <strong>update mode</strong> gdje se postojeći artikli ažuriraju prema "code" polju</li>
        <li>Provjerite postoji li opcija "Ažuriraj postojeće" pri upload-u</li>
        <li>Alternativno: izvezite artikle, izmjenite ih u Excelu, obrišite stare i uvezite nove</li>
      </ul>
    </details>

    <details>
      <summary>Koliko artikala mogu učitati odjednom?</summary>
      <p>Tehnička ograničenja:</p>
      <ul>
        <li><strong>Preporučeno:</strong> Do 500 artikala po CSV datoteci</li>
        <li><strong>Maksimum:</strong> Ovisi o serveru, obično 1000-2000</li>
        <li><strong>Za veće količine:</strong> Podijelite u više manjih CSV datoteka</li>
      </ul>
      <p>Upload velikih datoteka može trajati nekoliko minuta - budite strpljivi i ne osvježavajte stranicu.</p>
    </details>

    <details>
      <summary>Treba li dodati artikle na cjenik nakon uvoza?</summary>
      <p>Da! Uvoz CSV-a dodaje artikle u <strong>bazu artikala</strong>, ali ne i na <strong>cjenik</strong>:</p>
      <ol>
        <li>Nakon uvoza, idite na "Cjenik"</li>
        <li>Dodajte uvezene artikle na cjenik s cijenama</li>
        <li>Ili koristite funkciju "Grupno dodavanje na cjenik" ako je dostupna</li>
      </ol>
    </details>
  `
}

function getItemsKpdSifraContent () {
  return `
    <h2 id="what-is">Što je KPD Šifra?</h2>
    <p><strong>KPD Šifra</strong> (Klasifikacija proizvoda po djelatnostima) je šifra koja kategorizira proizvode i usluge prema standardnoj klasifikaciji. Potrebna je za <strong>eRacun</strong> sustav i koristi se za pravilnu kategorizaciju stavki na elektroničkim računima.</p>

    <div class="info-box">
      <i class="mdi mdi-information" style="color: #3989C9; margin-right: 8px; font-size: 20px;"></i>
      <div>
        <strong>Važno:</strong> KPD Šifra je obavezna za sve stavke na računu kada je aktivan eRacun. Bez KPD šifri, eRacun ne može biti poslan.
      </div>
    </div>

    <h2 id="when-needed" class="mt-6">Kada je potrebna?</h2>
    <ul>
      <li>Kod slanja <strong>eRacuna</strong> pravnim osobama u Hrvatskoj</li>
      <li>Za sve stavke na računu koji će biti proslijeđen kao eRacun</li>
      <li>Obavezna za B2B transakcije s elektroničkim računima</li>
      <li>Zahtjev za kupcima iz Hrvatske s kompletnim podacima</li>
    </ul>

    <div class="warning-box">
      <i class="mdi mdi-alert" style="color: #FF9800; margin-right: 8px; font-size: 20px;"></i>
      <div>
        <strong>Napomena:</strong> Ako želite koristiti eRacun, sve stavke moraju imati unesenu KPD šifru. Sustav automatski provjerava ovaj uvjet.
      </div>
    </div>

    <h2 id="prerequisites" class="mt-6">Preduvjeti</h2>
    <ul>
      <li>Pristup modulu za unos/uređivanje računa</li>
      <li>Znanje o odgovarajućim KPD šiframa za vaše proizvode</li>
      <li>Omogućena opcija eRacuna u sustavu</li>
    </ul>

    <h2 id="step-by-step" class="mt-6">Korak po korak</h2>

    <h3 class="mt-4">1. Dodavanje KPD šifre pri kreiranju stavke</h3>
    <p>Najjednostavniji način je dodati KPD šifru odmah pri unosu stavki:</p>
    <ol>
      <li>Otvorite prozor za izdavanje računa ili kreiranje predloška</li>
      <li>U popisu stavki (košarici) pronaći ćete kolonu <strong>"KPD Šifra"</strong></li>
      <li>Kolona se nalazi nakon kolone <strong>"Popust%"</strong></li>
      <li>Kliknite u polje "KPD Šifra" za određenu stavku</li>
      <li>Unesite odgovarajuću šifru (npr. "10", "20", "30")</li>
      <li>Pritisnite Enter ili kliknite van polja za spremanje</li>
    </ol>

    <div class="success-box">
      <i class="mdi mdi-lightbulb" style="color: #4CAF50; margin-right: 8px; font-size: 20px;"></i>
      <div>
        <strong>Savjet:</strong> KPD Šifra polje ima maksimalnu širinu 150px i gustog je dizajna (dense outlined) za bolje iskustvo unosa.
      </div>
    </div>

    <h3 class="mt-4">2. Uređivanje KPD šifre postojeće stavke</h3>
    <p>Možete urediti KPD šifru u različitim dijelovima sustava:</p>

    <h4 class="mt-3">Opcija A: U EditReceiptDialog</h4>
    <ol>
      <li>Otvorite račun za uređivanje</li>
      <li>U tablici stavki pronađite kolonu "KPD Šifra"</li>
      <li>Kliknite u polje za stavku koju želite izmijeniti</li>
      <li>Unesite novu vrijednost</li>
      <li><strong>Napomena:</strong> Za učitane stavke postoji "edit-once" logika - polje se može urediti samo jednom nakon učitavanja</li>
    </ol>

    <h4 class="mt-3">Opcija B: U CrudTemplateDialog</h4>
    <ol>
      <li>Otvorite predložak računa</li>
      <li>Ista funkcionalnost kao u EditReceiptDialog</li>
      <li>KPD Šifra se čuva s predloškom</li>
    </ol>

    <h4 class="mt-3">Opcija C: U DefaultItemsView (Wizard)</h4>
    <ol>
      <li>Pri izdavanju računa preko wizard-a</li>
      <li>U koraku odabira stavki</li>
      <li>Svaka stavka ima polje "KPD Šifra"</li>
      <li>Unesite šifre za sve stavke prije nastavka</li>
    </ol>

    <h3 class="mt-4">3. KPD šifra na računu</h3>
    <p>Prikaz i pozicija KPD šifre na računu:</p>
    <table class="info-table">
      <thead>
        <tr>
          <th>Element</th>
          <th>Opis</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td><strong>Pozicija</strong></td>
          <td>Kolona nakon "Popust%"</td>
        </tr>
        <tr>
          <td><strong>Vidljivost</strong></td>
          <td>Vidljiva u košarici/popisu stavki</td>
        </tr>
        <tr>
          <td><strong>Obaveznost</strong></td>
          <td>Obavezna ako je eRacun aktivan</td>
        </tr>
        <tr>
          <td><strong>Format</strong></td>
          <td>Tekstualno polje (brojevi ili alfanumerički znakovi)</td>
        </tr>
      </tbody>
    </table>

    <h3 class="mt-4">4. Data flow do API-ja</h3>
    <p>KPD šifra se prenosi kroz sustav na sljedeći način:</p>
    <ol>
      <li><strong>Unos:</strong> Korisnik unosi u DefalutItemsView ili dialog</li>
      <li><strong>Pohranjivanje:</strong> Šifra se sprema u <code>item.kpdcode</code> property</li>
      <li><strong>Cart processing:</strong> templatePayment.js kopira kpdcode u <code>item.data</code></li>
      <li><strong>Item remapping:</strong> items.js uključuje kpdcode u finalnu strukturu stavke</li>
      <li><strong>API poziv:</strong> receiptApi prima kpdcode za svaku stavku</li>
    </ol>

    <h2 id="format" class="mt-6">Format i validacija</h2>
    <p>KPD šifra ima sljedeća pravila:</p>

    <table class="info-table">
      <thead>
        <tr>
          <th>Svojstvo</th>
          <th>Pravilo</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td><strong>Tip</strong></td>
          <td>Tekstualno polje (string)</td>
        </tr>
        <tr>
          <td><strong>Duljina</strong></td>
          <td>Obično 2-4 znaka (ovisno o standardu)</td>
        </tr>
        <tr>
          <td><strong>Dozvoljena polja</strong></td>
          <td>Brojevi i slova (ovisno o sustavu KPD)</td>
        </tr>
        <tr>
          <td><strong>Prazno polje</strong></td>
          <td>Dozvoljeno, ali onemogućava eRacun</td>
        </tr>
      </tbody>
    </table>

    <h3 class="mt-4">Česte KPD šifre</h3>
    <p>Ovo su neke od najčešće korištenih KPD šifri:</p>
    <table class="info-table">
      <thead>
        <tr>
          <th>Šifra</th>
          <th>Kategorija</th>
          <th>Primjer proizvoda</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td><strong>10</strong></td>
          <td>Gotova roba</td>
          <td>Hrana, pića, gotovi proizvodi</td>
        </tr>
        <tr>
          <td><strong>20</strong></td>
          <td>Usluge</td>
          <td>Frizura, servis, popravak</td>
        </tr>
        <tr>
          <td><strong>30</strong></td>
          <td>Trgovačka roba</td>
          <td>Preprodaja proizvoda</td>
        </tr>
        <tr>
          <td><strong>40</strong></td>
          <td>Sirovine</td>
          <td>Materijali za proizvodnju</td>
        </tr>
      </tbody>
    </table>

    <div class="info-box">
      <i class="mdi mdi-information" style="color: #3989C9; margin-right: 8px; font-size: 20px;"></i>
      <div>
        <strong>Napomena:</strong> Ove šifre su primjer. Koristite službene KPD šifre prema vašem poslovanju i zakonskim zahtjevima.
      </div>
    </div>

    <h2 id="tips" class="mt-6">Savjeti i trikovi</h2>
    <ul>
      <li><strong>Postavljanje defaultnih vrijednosti:</strong> Postavite KPD šifre direktno na artikle u bazi, ne unositi ručno svaki put</li>
      <li><strong>Kategorije i KPD:</strong> Grupirajte artikle po kategorijama i dodijelite iste KPD šifre sličnim proizvodima</li>
      <li><strong>Excel import:</strong> Ako učitavate artikle putem CSV-a, dodajte KPD šifre u datoteku</li>
      <li><strong>Predlošci:</strong> Kreirajte predloške računa s već popunjenim KPD šiframa za česte transakcije</li>
      <li><strong>Dokumentacija:</strong> Vodite listu KPD šifri koje koristite za lakše snalaženje</li>
      <li><strong>Provjera prije slanja:</strong> Prije aktivacije eRacuna, pregledajte da sve stavke imaju šifre</li>
    </ul>

    <h2 id="troubleshooting" class="mt-6">Što ako...?</h2>

    <details>
      <summary>Ne znam KPD šifru za moj artikl?</summary>
      <p>KPD šifre se određuju prema djelatnosti i vrsti proizvoda/usluge:</p>
      <ol>
        <li>Provjerite službene tablice KPD klasifikacije</li>
        <li>Kontaktirajte vašeg računovođu za preporuku</li>
        <li>Pogledajte slične proizvode u vašoj branši</li>
        <li>Za osnovne slučajeve:
          <ul>
            <li><strong>10</strong> - za gotove proizvode (hrana, pića)</li>
            <li><strong>20</strong> - za usluge</li>
            <li><strong>30</strong> - za trgovačku robu</li>
          </ul>
        </li>
      </ol>
    </details>

    <details>
      <summary>KPD polje je prazno - što da radim?</summary>
      <p>Ako KPD polje nema vrijednost:</p>
      <ul>
        <li>Unesite odgovarajuću šifru ručno u polje</li>
        <li>Ako je više stavki bez šifre, popunite svaku redom</li>
        <li><strong>Važno:</strong> Bez KPD šifri, eRacun neće biti dostupan</li>
        <li>Sustav će onemogućiti eRacun checkbox dok sve stavke nemaju šifre</li>
      </ul>
    </details>

    <details>
      <summary>eRacun ne radi zbog KPD šifre - kako to provjeriti?</summary>
      <p>Validacija KPD šifri za eRacun:</p>
      <ol>
        <li>Pregledajte sve stavke na računu</li>
        <li>Provjerite kolonu "KPD Šifra"</li>
        <li>Ako bilo koja stavka nema šifru:
          <ul>
            <li>eRacun checkbox će biti onemogućen (siv)</li>
            <li>Sustav obično prikazuje poruku "Sve stavke moraju imati KPD šifru"</li>
          </ul>
        </li>
        <li>Dodajte šifre svim stavkama koje ih nemaju</li>
        <li>eRacun checkbox će postati aktivan kada su sve šifre unesene</li>
      </ol>
    </details>

    <details>
      <summary>Mogu li promijeniti KPD šifru nakon što je račun kreiran?</summary>
      <p>Mogućnost izmjene ovisi o statusu računa:</p>
      <ul>
        <li><i class="mdi mdi-check" style="color: #4CAF50; margin-right: 4px;"></i> <strong>Draft/otvoreni račun:</strong> Da, možete izmijeniti prije finalizacije</li>
        <li><i class="mdi mdi-close" style="color: #F44336; margin-right: 4px;"></i> <strong>Finalizirani račun:</strong> Ne, KPD šifra je fiksna</li>
        <li><i class="mdi mdi-close" style="color: #F44336; margin-right: 4px;"></i> <strong>Poslani eRacun:</strong> Ne može se mijenjati</li>
      </ul>
      <p><strong>Napomena:</strong> Za učitane stavke u EditReceiptDialog postoji "edit-once" logika.</p>
    </details>

    <details>
      <summary>Gdje pronaći listu svih KPD šifri?</summary>
      <p>Službene KPD šifre možete pronaći:</p>
      <ol>
        <li><strong>Državni zavod za statistiku:</strong> Službene tablice KPD klasifikacije</li>
        <li><strong>Vaš računovođa:</strong> Može preporučiti šifre specifične za vašu djelatnost</li>
        <li><strong>Porezna uprava:</strong> Dokumentacija za eRacun sustav</li>
        <li><strong>Branšne udruge:</strong> Često imaju pripremljene liste za specifične industrije</li>
      </ol>
      <div class="info-box">
        <i class="mdi mdi-information" style="color: #3989C9; margin-right: 8px; font-size: 20px;"></i>
        <div>
          Za više informacija o korištenju KPD šifri s eRacunom, pogledajte <strong>Postavke → Fiskalizacija i eRacun</strong> u ovom priručniku.
        </div>
      </div>
    </details>

    <details>
      <summary>Može li KPD šifra imati slova ili samo brojeve?</summary>
      <p>Format KPD šifre ovisi o sustavu:</p>
      <ul>
        <li>Najčešće su <strong>brojevi</strong> (npr. "10", "20", "30")</li>
        <li>Neki sustavi dozvoljavaju alfanumeričke šifre</li>
        <li>Sustav AI Kasa prihvaća tekstualno polje, što znači da su dozvoljeni i brojevi i slova</li>
        <li>Preporučujemo koristiti službene šifre prema standardu</li>
      </ul>
    </details>

    <details>
      <summary>Što ako imam puno artikala bez KPD šifri?</summary>
      <p>Za grupno dodavanje KPD šifri:</p>
      <ol>
        <li><strong>Direktno na artiklima:</strong>
          <ul>
            <li>Idite u modul Artikli</li>
            <li>Uredite svaki artikl i dodajte default KPD šifru</li>
            <li>KPD šifra će se automatski primjenjivati na nove račune</li>
          </ul>
        </li>
        <li><strong>Grupno uređivanje:</strong>
          <ul>
            <li>Ako je dostupna funkcionalnost, odaberite više artikala</li>
            <li>Primjenite istu KPD šifru na sve</li>
          </ul>
        </li>
        <li><strong>CSV import:</strong>
          <ul>
            <li>Export-ajte artikle u CSV</li>
            <li>Dodajte KPD šifre u Excel-u</li>
            <li>Import-ajte natrag (ako je podržano ažuriranje)</li>
          </ul>
        </li>
      </ol>
    </details>
  `
}

function getItemsBulkKpdContent () {
  return `
    <h2 id="what-is">Što je grupni unos KPD šifri?</h2>
    <p><strong>Bulk unos KPD šifri</strong> omogućava brzo dodavanje ili ažuriranje KPD šifri za veći broj artikala odjednom. Ova funkcionalnost značajno ubrzava proces postavljanja KPD kodova, posebno kada trebate pripremiti veliki broj artikala za eRacun sustav.</p>

    <div class="info-box">
      <i class="mdi mdi-information" style="color: #3989C9; margin-right: 8px; font-size: 20px;"></i>
      <div>
        <strong>Korisno za:</strong> Brzo postavljanje KPD šifri za sve artikle u jednoj ili više kategorija, ili ažuriranje šifri za artikle koji ih još nemaju.
      </div>
    </div>

    <h2 id="when-to-use" class="mt-6">Kada koristiti?</h2>
    <ul>
      <li>Kada trebate postaviti KPD šifre za veliki broj novih artikala</li>
      <li>Pri pripremi artikala za korištenje eRacun sustava</li>
      <li>Za ažuriranje postojećih KPD šifri kada se promijene standardi</li>
      <li>Kada želite dodijeliti istu KPD šifru svim artiklima u određenoj kategoriji</li>
      <li>Pri migraciji na novi sustav ili dodavanju novog prodajnog mjesta</li>
    </ul>

    <h2 id="prerequisites" class="mt-6">Preduvjeti</h2>
    <ul>
      <li>Pristup modulu <strong>"Artikli" → "KPD Šifra"</strong></li>
      <li>Odabrano prodajno mjesto</li>
      <li>Artikli moraju biti dodani u cjenik za odabrano prodajno mjesto</li>
      <li>Znanje o odgovarajućim KPD šiframa za vaše kategorije proizvoda</li>
    </ul>

    <h2 id="step-by-step" class="mt-6">Korak po korak</h2>

    <h3 class="mt-4">1. Pristup bulk update funkciji</h3>
    <ol>
      <li>Otvorite <strong>"Artikli" → "KPD Šifra"</strong> modul</li>
      <li>Odaberite <strong>prodajno mjesto</strong> iz dropdown izbornika (ako imate više lokacija)</li>
      <li>U filteru na vrhu stranice pronaći ćete gumb <strong>"Bulk Update"</strong></li>
      <li>Kliknite na gumb da otvorite dialog za grupni unos</li>
    </ol>

    <div class="success-box">
      <i class="mdi mdi-lightbulb" style="color: #4CAF50; margin-right: 8px; font-size: 20px;"></i>
      <div>
        <strong>Savjet:</strong> Prije korištenja bulk update, preporučamo korištenje filtera da smanjite listu artikala i lakše pratite promjene.
      </div>
    </div>

    <h3 class="mt-4">2. Korištenje filtera</h3>
    <p>Prije bulk update-a, možete filtrirati artikle po različitim kriterijima:</p>

    <table class="info-table">
      <thead>
        <tr>
          <th>Filter</th>
          <th>Opis</th>
          <th>Primjena</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td><strong>Prodajno mjesto</strong></td>
          <td>Lokacija za koju postavljate KPD šifre</td>
          <td>Obavezno ako imate više lokacija</td>
        </tr>
        <tr>
          <td><strong>Naziv artikla</strong></td>
          <td>Pretraga po nazivu</td>
          <td>Pronalaženje specifičnih artikala</td>
        </tr>
        <tr>
          <td><strong>KPD šifra</strong></td>
          <td>Pretraga po postojećoj šifri</td>
          <td>Pronalaženje artikala s određenom šifrom</td>
        </tr>
        <tr>
          <td><strong>Kategorije</strong></td>
          <td>Filtriranje po kategorijama</td>
          <td>Rad s artiklima iz određenih kategorija</td>
        </tr>
        <tr>
          <td><strong>KPD Status</strong></td>
          <td>Ima/Nema KPD šifru</td>
          <td>Pronalaženje artikala bez šifri</td>
        </tr>
      </tbody>
    </table>

    <h3 class="mt-4">3. Odabir kategorija za bulk update</h3>
    <p>U Bulk Update dialogu:</p>
    <ol>
      <li>Vidjet ćete listu svih dostupnih kategorija</li>
      <li>Odaberite jednu ili više kategorija čijim artiklima želite postaviti KPD šifru</li>
      <li>Možete koristiti "Select All" za brzi odabir svih kategorija</li>
      <li>Svaka kategorija prikazuje broj artikala koji će biti ažurirani</li>
    </ol>

    <h3 class="mt-4">4. Unos KPD šifre</h3>
    <ol>
      <li>U polje <strong>"KPD Šifra"</strong> unesite željenu šifru</li>
      <li>Šifra će biti primjenjena na sve artikle iz odabranih kategorija</li>
      <li>Format šifre: obično 2-4 znaka (npr. "10", "20", "30")</li>
      <li>Provjerite je li šifra ispravna prije potvrde</li>
    </ol>

    <div class="warning-box">
      <i class="mdi mdi-alert" style="color: #FF9800; margin-right: 8px; font-size: 20px;"></i>
      <div>
        <strong>Važno:</strong> Bulk update će <strong>prepisati</strong> postojeće KPD šifre za sve artikle u odabranim kategorijama. Provjerite odabir prije potvrde!
      </div>
    </div>

    <h3 class="mt-4">5. Pregled i potvrda</h3>
    <ol>
      <li>Dialog prikazuje koliko artikala će biti ažurirano</li>
      <li>Provjerite odabrane kategorije i unesenu KPD šifru</li>
      <li>Kliknite <strong>"Ažuriraj"</strong> ili <strong>"Spremi"</strong> za potvrdu</li>
      <li>Sustav prikazuje progress bar tijekom ažuriranja</li>
      <li>Nakon završetka, vidjet ćete potvrdu o broju ažuriranih artikala</li>
    </ol>

    <h3 class="mt-4">6. Inline uređivanje pojedinačnih artikala</h3>
    <p>Nakon bulk update-a, možete urediti pojedinačne KPD šifre:</p>
    <ol>
      <li>U listi artikala, pronađite kolonu <strong>"KPD Šifra"</strong></li>
      <li>Kliknite na chip s KPD šifrom (prikazuje trenutnu šifru ili "Dodaj KPD")</li>
      <li>Otvara se inline editor s text poljem</li>
      <li>Unesite novu vrijednost</li>
      <li>Pritisnite <strong>Enter</strong> ili kliknite <i class="mdi mdi-check" style="color: #4CAF50;"></i> za spremanje</li>
      <li>Ili pritisnite <strong>Esc</strong> ili kliknite <i class="mdi mdi-close" style="color: #F44336;"></i> za odustajanje</li>
    </ol>

    <h2 id="interface" class="mt-6">Sučelje i značajke</h2>

    <h3 class="mt-4">Prikaz artikala</h3>
    <p>Svaki artikl u listi prikazuje:</p>
    <table class="info-table">
      <thead>
        <tr>
          <th>Element</th>
          <th>Opis</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td><strong>Slika</strong></td>
          <td>Slika artikla (ako postoji)</td>
        </tr>
        <tr>
          <td><strong>Naziv</strong></td>
          <td>Puni naziv artikla i šifra</td>
        </tr>
        <tr>
          <td><strong>Kategorije</strong></td>
          <td>Chipovi s kategorijama kojima artikl pripada</td>
        </tr>
        <tr>
          <td><strong>KPD Šifra</strong></td>
          <td>Chip s trenutnom šifrom ili "Dodaj KPD" ako nema</td>
        </tr>
        <tr>
          <td><strong>Akcije</strong></td>
          <td>Ikona olovke za brzo uređivanje</td>
        </tr>
      </tbody>
    </table>

    <h3 class="mt-4">Boje i indikatori</h3>
    <table class="info-table">
      <thead>
        <tr>
          <th>Boja chipa</th>
          <th>Značenje</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td><span class="status-chip" style="background-color: #00B3BE; color: white;">Teal</span></td>
          <td>Artikl ima KPD šifru</td>
        </tr>
        <tr>
          <td><span class="status-chip grey" style="color: white;">Siva</span></td>
          <td>Artikl nema KPD šifru (prikazuje "Dodaj KPD")</td>
        </tr>
      </tbody>
    </table>

    <h3 class="mt-4">Paginacija</h3>
    <ul>
      <li>Stranica učitava 20 artikala odjednom</li>
      <li>Koristite gumb <strong>"Učitaj više"</strong> za dodatne artikle</li>
      <li>Scroll automatski pozicionira na prethodno učitane artikle</li>
      <li>Indikator na dnu prikazuje "Nema više artikala" kada su svi učitani</li>
    </ul>

    <h2 id="use-cases" class="mt-6">Primjeri korištenja</h2>

    <h3 class="mt-4">Scenario 1: Postavljanje KPD šifri za restoran</h3>
    <details>
      <summary>Kliknite za detalje</summary>
      <ol>
        <li>Otvorite "Artikli" → "KPD Šifra"</li>
        <li>Odaberite prodajno mjesto (npr. "Restoran Centar")</li>
        <li>Kliknite "Bulk Update"</li>
        <li>Odaberite kategoriju "Jela"</li>
        <li>Unesite KPD šifru: <strong>10</strong> (gotova roba)</li>
        <li>Potvrda - sva jela sada imaju KPD 10</li>
        <li>Ponovite za kategoriju "Pića" s KPD šifrom <strong>10</strong></li>
        <li>Za kategoriju "Usluge" postavite KPD <strong>20</strong></li>
      </ol>
    </details>

    <h3 class="mt-4">Scenario 2: Ispravljanje postojećih KPD šifri</h3>
    <details>
      <summary>Kliknite za detalje</summary>
      <ol>
        <li>Koristite filter "KPD Status" → "Ima KPD šifru"</li>
        <li>Pretraživanje po "KPD šifri" → unesite staru šifru (npr. "01")</li>
        <li>Vidite sve artikle sa šifrom "01"</li>
        <li>Kliknite "Bulk Update"</li>
        <li>Odaberite sve relevantne kategorije</li>
        <li>Unesite novu šifru: <strong>10</strong></li>
        <li>Potvrda - sve šifre "01" zamijenjene s "10"</li>
      </ol>
    </details>

    <h3 class="mt-4">Scenario 3: Dodavanje KPD šifri artiklima bez njih</h3>
    <details>
      <summary>Kliknite za detalje</summary>
      <ol>
        <li>Postavite filter "KPD Status" → "Nema KPD šifru"</li>
        <li>Vidite samo artikle bez KPD šifre</li>
        <li>Dodatno filtrirajte po "Kategorije" ako želite</li>
        <li>Kliknite "Bulk Update"</li>
        <li>Odaberite kategorije za koje znate ispravnu šifru</li>
        <li>Unesite odgovarajuću KPD šifru</li>
        <li>Za preostale artikle koristite inline editing</li>
      </ol>
    </details>

    <h2 id="tips" class="mt-6">Savjeti i trikovi</h2>
    <ul>
      <li><strong>Planirajte unaprijed:</strong> Napravite listu kategorija i njihovih KPD šifri prije početka</li>
      <li><strong>Koristite filtere:</strong> Filtrirajte artikle prije bulk update-a za bolju kontrolu</li>
      <li><strong>Radite u fazama:</strong> Prvo bulk update za velike kategorije, zatim inline editing za specifične artikle</li>
      <li><strong>Provjerite prije potvrde:</strong> Bulk update prepisuje postojeće šifre - uvijek provjerite odabir</li>
      <li><strong>Standardne šifre:</strong> Dogovorite standardne šifre s računovođom i držite se ih</li>
      <li><strong>Dokumentirajte:</strong> Vodite listu kategorija i njihovih KPD šifri za referencu</li>
      <li><strong>Testirajte prvo:</strong> Probajte s jednom kategorijom prije nego radite bulk update za sve</li>
    </ul>

    <h2 id="troubleshooting" class="mt-6">Što ako...?</h2>

    <details>
      <summary>Bulk Update gumb je onemogućen (disabled)?</summary>
      <p>Gumb zahtijeva odabrano prodajno mjesto:</p>
      <ul>
        <li>Provjerite je li odabrano prodajno mjesto u dropdown izborniku</li>
        <li>Ako imate samo jedno prodajno mjesto, trebalo bi biti automatski odabrano</li>
        <li>Ako vidite poruku "Molimo odaberite prodajno mjesto", odaberite lokaciju</li>
      </ul>
    </details>

    <details>
      <summary>Ne vidim sve artikle u listi?</summary>
      <p>Lista koristi paginaciju i filtere:</p>
      <ol>
        <li>Provjerite aktivne filtere - možda skrivaju neke artikle</li>
        <li>Koristite gumb "Učitaj više" na dnu liste</li>
        <li>Provjerite je li odabrano ispravno prodajno mjesto</li>
        <li>Artikli moraju biti dodani na cjenik za odabrano prodajno mjesto</li>
      </ol>
    </details>

    <details>
      <summary>Bulk update nije ažurirao sve artikle?</summary>
      <p>Mogući razlozi:</p>
      <ul>
        <li>Nisu odabrane sve relevantne kategorije - provjerite odabir</li>
        <li>Neki artikli možda nisu u odabranim kategorijama</li>
        <li>Artikli možda nemaju kategoriju dodijeljenu - dodajte kategorije prvo</li>
        <li>Provjerite mrežnu vezu - ažuriranje zahtijeva aktivnu konekciju</li>
      </ul>
    </details>

    <details>
      <summary>Kako mogu vidjeti koji artikli nemaju KPD šifru?</summary>
      <ol>
        <li>Postavite filter "KPD Status" na "Nema KPD šifru"</li>
        <li>Lista će prikazati samo artikle bez šifre</li>
        <li>Chipovi će biti sivi s tekstom "Dodaj KPD"</li>
        <li>Možete kombinirati s kategorijama filterom za preciznije rezultate</li>
      </ol>
    </details>

    <details>
      <summary>Mogu li ažurirati KPD šifre za više prodajnih mjesta odjednom?</summary>
      <p>Ne, bulk update radi za jedno prodajno mjesto odjednom:</p>
      <ol>
        <li>Odaberite prvo prodajno mjesto</li>
        <li>Izvršite bulk update</li>
        <li>Promijenite prodajno mjesto</li>
        <li>Ponovite postupak za drugo mjesto</li>
      </ol>
      <p><strong>Napomena:</strong> Ovo osigurava da ne dođe do grešaka i da imate potpunu kontrolu nad promjenama.</p>
    </details>

    <details>
      <summary>Bulk update je prepisao pogrešne šifre - mogu li to vratiti?</summary>
      <p>Nažalost, bulk update nema "undo" funkciju:</p>
      <ul>
        <li>Morat ćete ručno ispraviti šifre</li>
        <li>Koristite bulk update ponovo za vraćanje starih šifri</li>
        <li>Ili koristite inline editing za pojedinačne ispravke</li>
      </ul>
      <div class="warning-box">
        <i class="mdi mdi-alert" style="color: #FF9800; margin-right: 8px; font-size: 20px;"></i>
        <div>
          <strong>Prevencija:</strong> Uvijek pažljivo provjerite odabir kategorija i unesenu šifru prije potvrde bulk update-a!
        </div>
      </div>
    </details>

    <details>
      <summary>Koliko artikala mogu ažurirati odjednom?</summary>
      <p>Nema ograničenja broja artikala u bulk update-u:</p>
      <ul>
        <li>Možete odabrati sve kategorije odjednom</li>
        <li>Sustav automatski ažurira sve artikle u odabranim kategorijama</li>
        <li>Progress bar prikazuje napredak tijekom ažuriranja</li>
        <li>Za veoma veliki broj artikala (1000+), postupak može potrajati nekoliko minuta</li>
      </ul>
    </details>

    <details>
      <summary>Mogu li izvesti listu artikala s KPD šiframa?</summary>
      <p>Trenutno export funkcija nije dostupna u KPD Šifra modulu:</p>
      <ul>
        <li>Možete koristiti pretraživanje i filtere za pregled</li>
        <li>Za export, koristite "Artikli i cjenik" → "Export" funkciju</li>
        <li>Ili kontaktirajte podršku za bulk izvoz KPD šifri</li>
      </ul>
    </details>

    <h2 id="related" class="mt-6">Povezane teme</h2>
    <ul>
      <li><strong>KPD Šifra</strong> - Opći vodič o KPD šiframa i njihovoj uporabi</li>
      <li><strong>Postavke → Fiskalizacija i eRacun</strong> - Kako KPD šifre utječu na eRacun</li>
      <li><strong>Kategorije</strong> - Upravljanje kategorijama artikala</li>
      <li><strong>Artikli → Dodavanje artikla</strong> - Dodavanje novih artikala u sustav</li>
    </ul>

    <div class="info-box">
      <i class="mdi mdi-information" style="color: #3989C9; margin-right: 8px; font-size: 20px;"></i>
      <div>
        <strong>Napomena:</strong> Za više informacija o KPD šiframa i njihovoj povezanosti s eRacunom, pogledajte sekcije <strong>KPD Šifra</strong> i <strong>Postavke → Fiskalizacija i eRacun</strong> u ovom priručniku.
      </div>
    </div>
  `
}
